import { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../../components/ui/command';
import { Check, ChevronsUpDown, PlusCircle } from 'lucide-react';

// Searchable picker for large lists (vendors ~1900, properties) with an optional "create new" entry.
export const SearchCombobox = ({ items, value, onChange, onCreate, createLabel = 'Create new', placeholder, display, testid }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ql = q.toLowerCase();
  const filtered = (q ? items.filter(i => (i.name || '').toLowerCase().includes(ql)) : items).slice(0, 80);
  const label = display || items.find(i => i.id === value)?.name || '';
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="h-8 w-full justify-between text-xs font-normal" data-testid={testid}>
          <span className={label ? 'truncate' : 'text-muted-foreground'}>{label || placeholder}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Search…" value={q} onValueChange={setQ} data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No matches.</CommandEmpty>
            <CommandGroup>
              {onCreate && (
                <CommandItem value="__create__" onSelect={() => { onCreate(q); setOpen(false); }} data-testid={`${testid}-create`}>
                  <PlusCircle className="mr-2 h-3.5 w-3.5 text-primary" /> {createLabel}{q ? ` “${q}”` : ''}
                </CommandItem>
              )}
              {filtered.map(i => (
                <CommandItem key={i.id} value={i.id} onSelect={() => { onChange(i.id); setOpen(false); }}>
                  <Check className={`mr-2 h-3.5 w-3.5 ${value === i.id ? 'opacity-100' : 'opacity-0'}`} />
                  <span className="truncate">{i.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
